import { Brand, createBranded } from '@deltasierra/type-utilities';

/**
 * @deprecated Use the `LearnTagId` instead.
 */
export type TryThisTagId = Brand<number, 'TryThisTagId'>;
/**
 * @deprecated Use the `LearnTagId` instead.
 */
export const TryThisTagId = createBranded<TryThisTagId>();
